import React from 'react';

const cleanPercentage = (percentage) => {
    const isNegativeOrNaN = !Number.isFinite(+percentage) || percentage < 0; // we can set non-numbers to 0 here
    const isTooHigh = percentage > 100;
    return isNegativeOrNaN ? 0 : isTooHigh ? 100 : +percentage;
};

const Circle = ({ color, value, strokeWidth, radius }) => {
    const r = radius;
    const circ = 2 * Math.PI * r;
    const strokePct = ((100 - value) * circ) / 100; // where stroke will start, e.g. from 15% to 100%.
    return (
        <circle
            r={r}
            cx={100}
            cy={100}
            fill="transparent"
            stroke={strokePct !== circ ? color : ""} // remove colour as 0% sets full circumference
            strokeWidth={strokeWidth}
            strokeDasharray={circ}
            strokeDashoffset={value ? strokePct : 0}
            // strokeLinecap="round"
        />
    );
};

const Text = ({ value }) => {
    return (
        <text
            x="50%"
            y="50%"
            dominantBaseline="central"
            textAnchor="middle"
            fontSize={"1em"}>
            {value.toFixed(0)}%
        </text>
    );
};

const ProgressCircle = ({ value, color, displayText, strokeWidth="2rem", radius=70, text}) => {
    const pct = cleanPercentage(value);
    return (
        <svg width="100%" height="100%"  viewBox="0 0 100 100">
            <g transform={`rotate(-90 50 100)`}>
                <Circle color="lightgrey" strokeWidth={strokeWidth} radius={radius} />
                <Circle color={color} value={pct} strokeWidth={strokeWidth} radius={radius} />
            </g>
            {displayText && <Text value={pct} />}
        </svg>
    );
};

export default ProgressCircle;